import "react-day-picker/style.css";

import { format } from "date-fns";
import { ja } from "date-fns/locale";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
import * as React from "react";
import { DayPicker } from "react-day-picker";
import { cn } from "src/utils/css.util";

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

function Calendar({
  className,
  classNames,
  // showOutsideDays = true,
  ...props
}: CalendarProps) {
  return (
    <DayPicker
      locale={ja}
      className={cn("p-3", className)}
      classNames={{
        ...classNames,
      }}
      components={{
        Chevron: (props) => {
          if (props.orientation === "left") {
            return <ChevronLeftIcon {...props} className="h-4 w-4" />;
          }
          return <ChevronRightIcon {...props} className="h-4 w-4" />;
        },
      }}
      formatters={{
        formatCaption: (date) => format(date, "yyyy年M月", { locale: ja }),
      }}
      {...props}
    />
  );
}
Calendar.displayName = "Calendar";

export { Calendar };
